import { Heading, Inline, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { headingStyles, inlineWrapper, travelerButtonDesktop, travelerDesktopContainer } from '../utils/styles';
import SingleTravelerButton from './SingleTravelerButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SeatMapTravelersDesktop = _ref => {
  let {
    activeSegment,
    onRemoveSeat,
    selectedSeats,
    seatTravelers,
    activeTraveler,
    onChange
  } = _ref;
  const {
    t
  } = useTranslation();
  const passengerInformationHeading = t('Product.SeatMap.Passenger.Information.Header.Label');
  return /*#__PURE__*/_jsxs(Stack, {
    className: travelerDesktopContainer,
    "data-testid": "seatMap-travelers",
    children: [/*#__PURE__*/_jsx(Heading, {
      className: headingStyles,
      level: 3,
      children: passengerInformationHeading
    }), /*#__PURE__*/_jsx(Inline, {
      className: inlineWrapper,
      children: /*#__PURE__*/_jsx(Stack, {
        className: travelerButtonDesktop,
        children: seatTravelers.map(traveler => /*#__PURE__*/_jsx(SingleTravelerButton, {
          activeSegment: activeSegment,
          activeTraveler: activeTraveler,
          onChange: onChange,
          onRemoveSeat: onRemoveSeat,
          selectedSeats: selectedSeats,
          traveler: traveler
        }, traveler.id))
      })
    })]
  });
};
export default SeatMapTravelersDesktop;
//# sourceMappingURL=SeatMapTravelersDesktop.js.map